import { provideAnimations } from '@angular/platform-browser/animations';
import { ApplicationConfig, ErrorHandler } from '@angular/core';
import { studentRecordRouteProvider } from './providers/student-record-route.provider';
import { provideHttpClient, withInterceptorsFromDi, withInterceptors } from '@angular/common/http';
import { provideRouter, withRouterConfig } from '@angular/router';
import { routes } from './app.routes';
import { environment } from '../environments/environment';
import { SystemService } from './services/system.service';
import { MsalTokenInterceptor } from '@k12/app-services';
import { SignalRService } from '@k12/app-services';
import { CFIErrorHandlerService } from '@k12/app-services';
import { apiRoutingInterceptor } from '@k12/app-services';
import { provideEnvironmentNgxMask } from 'ngx-mask';
import { InactivityMonitorService } from '@k12/app-services';
import { CommentsService } from '@k12/admin-services';
import { SHARED_ENVIRONMENT } from '@k12/app-services';
import {
	ISSUE_TRACKING_SERVICE,
	USER_RECORD_COMMENTS_SERVICE,
	USER_RECORD_COMMUNICATIONS_SERVICE,
	USER_RECORD_EMPLOYEE_SERVICE,
	USER_RECORD_MESSAGES_SERVICE,
	USER_RECORD_PROVIDER_DETAILS_SERVICE,
	USER_RECORD_SYSTEM_SERVICE
} from '@k12/admin-services';
import { CommunicationCenterDashboardService } from './pages/communications-center/communications-center.service';
import { MessageCenterService } from './pages/message_center/message_center.service';
import { EmployeeService } from './services/employee.service';
import { IssueTrackingService } from './services/issue-tracking.service';
import { ProviderRecordService } from './services/provider-record.service';

export const appConfig: ApplicationConfig = {
	providers: [
		{ provide: SHARED_ENVIRONMENT, useValue: environment },
		provideRouter(
			routes,
			withRouterConfig({
				paramsInheritanceStrategy: 'always',
				onSameUrlNavigation: 'reload'
			})
		),
		SignalRService,
		SystemService,
		provideAnimations(),
		provideEnvironmentNgxMask(),
		provideHttpClient(
			withInterceptorsFromDi(),
			withInterceptors([
				(req, next) => apiRoutingInterceptor(req, next),
				(req, next) => MsalTokenInterceptor(req, next)
			]),
		),
		{ provide: ErrorHandler, useClass: CFIErrorHandlerService },
		InactivityMonitorService,
		{ provide: ISSUE_TRACKING_SERVICE, useExisting: IssueTrackingService },
		{ provide: USER_RECORD_COMMENTS_SERVICE, useExisting: CommentsService },
		{ provide: USER_RECORD_COMMUNICATIONS_SERVICE, useExisting: CommunicationCenterDashboardService },
		{ provide: USER_RECORD_EMPLOYEE_SERVICE, useExisting: EmployeeService },
		{ provide: USER_RECORD_MESSAGES_SERVICE, useExisting: MessageCenterService },
		{ provide: USER_RECORD_SYSTEM_SERVICE, useExisting: SystemService },
		{ provide: USER_RECORD_PROVIDER_DETAILS_SERVICE, useExisting: ProviderRecordService },
		// Lights up the Student ID link on the shared roster; admin is the only app that provides it.
		studentRecordRouteProvider
	]
};
